var _ = require('underscore')
var t = {}

function parseSingularPlural (translation, param) {
  if (translation.match('::phrase::')) return translation
  var translationSingularPlural = translation.split('|')
  if (param === 1) {
    return _.first(translationSingularPlural)
  }
  return _.last(translationSingularPlural)
}

function translate (category, key, params) {
  params = params || {}

  var categoryTranslations = t[category] || {}
  var hasTranslation = !!categoryTranslations[key]
  var translation = categoryTranslations[key] || key

  translation = parseSingularPlural(
    translation,
    parseInt(_.first(_.values(params)), 10)
  )

  _.each(params, function (value, paramKey) {
    translation = translation.split('{' + paramKey + '}').join(value)
  })

  if (!hasTranslation) {
    translation = category + '|' + translation
  }

  return { translation, hasTranslation }
}

module.exports = {
  addTranslation: function (category, key, translation) {
    t[category] = t[category] || {}
    t[category][key] = translation
  },

  addTranslationDict: function (dict) {
    for (var category in dict) {
      t[category] = Object.assign({}, t[category], dict[category])
    }
  },

  translateOrEmpty: function () {
    const { hasTranslation, translation } = translate.apply(null, arguments)
    if (!hasTranslation) return ''
    return translation
  },

  translate: function () {
    return translate.apply(null, arguments).translation
  },

  // short alias
  t: function () {
    return translate.apply(null, arguments).translation
  }
}
